import Auth from './Auth'
import Cta from './Cta'
import Dashboards from './Dashboard'
import { createStore } from 'vuex'
import general from './general'
import Links from './Links'
import Domains from './Domains'
import Settings from './Settings'
import Subscription from './Subscription'
import Webhooks from './Webhooks'

export default createStore({
    state: {},
    getters: {},
    modules: {
        Auth,
        Cta,
        Dashboards,
        Links,
        Domains,
        Settings,
        Subscription,
        Webhooks,
        general
    },
    mutations: {
        updateAnyState (state, payload) {
            let obj = state
            let nmState = payload.shift()
            let nms = nmState.split('/')
            payload.unshift(...nms)
            let val = payload.pop()
            let key = payload.pop()
            payload.forEach((p) => {
                obj = obj[p]
            })
            obj[key] = val
        }
    },
    actions: {}
})
